<template>
  <div class="card-container">
    <app-form-header></app-form-header>
    <form class="form-container" @submit.prevent="handleSubmit">
      <div class="form1">
        <div class="form-group">
          <label for=""> Correction Type: <span class="required">*</span> </label>
          <div class="input">
            <select name="attendanceCorrType" v-model="attendanceCorrType" @change="handlerCategory">
              <option value="" disabled>-- Select Attendance Correction --</option>

              <option v-for="(types, index) in correctionTypes" :key="index" :value="types.code">
                {{ types.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="form-group">
          <label for=""> Date Intended: <span class="required">*</span> </label>
          <div class="input">
            <input type="date" v-model="formData.dateStart" @change="getDTRs()" :min="pastDates" />
          </div>
        </div>
        <div class="form-group dtr-group">
          <label for=""> Add Time: <span class="required">*</span> </label>
          <div class="dtr-time-list">
            <div style="display: flex; justify-content: space-between; align-items: center">
              <div class="dtr-row"><input type="time" v-model="timelog" :max="dtrOrigTimeOut" step="any" /></div>
              <div><input type="button" value="Add" @click="addTime" /></div>
            </div>

            <hr />
            <div class="input" v-for="entry in sortedDtrs" :key="entry.originalIndex" style="display: flex; align-items: center; justify-content: flex-start; gap: 10px">
              <div class="dtr-row" :class="{ 'dtr-row--new': entry.item.manual }">
                <input
                  :disabled="attendanceCorrType === 'MMTI' || attendanceCorrType === 'MMTO'"
                  type="time"
                  v-model="entry.item.timelog"
                  @change="hrsComputation(entry.item, entry.originalIndex)"
                  :max="dtrOrigTimeOut"
                  step="any"
                />
              </div>
              <div>
                <span class="io-label" :class="entry.item.io === 'I' ? 'io-in' : 'io-out'">
                  {{ entry.item.io === 'I' ? 'IN' : 'OUT' }}
                </span>
              </div>
              <div v-if="entry.item.manual">
                <span class="new-badge">New</span>
              </div>
              <div>
                <button type="button" class="remove-btn" @click="removeTime(entry.originalIndex)">Remove</button>
              </div>
            </div>
          </div>
        </div>
        <span v-show="isDTR"
          ><h5 class="required">{{ DTRRemarks }}</h5></span
        >
      </div>
      <div class="form2">
        <div class="form-group">
          <label for=""> Reason: </label>
          <div class="input">
            <textarea rows="5" v-model="formData.description" />
          </div>
        </div>
        <div class="form-group">
          <label for=""> Supporting Document: </label>
          <div class="fileinput input">
            <input ref="fileData" type="file" @change="selectFile(fileData)" />
          </div>
          <div v-if="!fileData"></div>
          <div>
            <h5 style="color: red">Note: Maximum upload file size: 5 MB</h5>
          </div>
          <div v-if="$store.state.errorFileSize" style="padding-top: 20px">
            <div class="alert-error form-alert">
              {{ $store.state.errorFileSize }}
            </div>
          </div>
          <div v-if="isAlert" style="padding-top: 20px">
            <div class="alert-error form-alert">
              {{ $store.state.errorMessage }}
            </div>
          </div>
        </div>
        <div class="form-group">
          <button class="submit" :disabled="buttonMessageVisible">
            {{ !buttonMessageVisible ? 'Submit' : 'Please wait...' }}
          </button>
        </div>
        <div v-show="isAlert">
          <div v-show="isStatus" class="alert-error form-alert">
            {{ $store.state.formErrorMessage }}
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { reactive, ref, computed, onMounted, inject } from 'vue';
import Swal from 'sweetalert2';

export default {
  setup(props, { emit }) {
    const axios = inject('$axios');
    const store = inject('$store');

    const isAlert = ref(false);
    const isStatus = ref(false);
    const isDTR = ref(false);
    const isInvalidTime = ref(false);
    const DTRRemarks = ref('');
    const pastDates = ref(null);
    const attendanceCorrType = ref('');
    const attendanceCategory = ref('');
    const dtrs = ref([]);
    const buttonMessageVisible = ref(false);
    const timelog = ref(null);
    const dtrOrigTimeOut = ref(null); // kept as reference; wire this to actual DTR time-out source if available

    // group: links a correction type (code) to the set of valid categories for it
    const correctionTypes = reactive([
      { name: 'Missing Morning Time In', code: 'MMTI', group: 'MT' },
      { name: 'Missing Morning Time Out', code: 'MMTO', group: 'MT' },
      /*{ name: "Incorrect Time-In", code: "ITI", group: "IT" },
      { name: "Incorrect Time-Out", code: "ITO", group: "IT" },
      { name: "Missed BioTime Logging", code: "MBL", group: "MBL" },*/
    ]);

    const categoryTypes = reactive([
      { name: 'Morning', code: 'MMTI', group: 'MT' },
      { name: 'Afternoon', code: 'MMTO', group: 'MT' },
    ]);

    // categories filtered to match the currently selected correction type's group
    const filteredCategoryTypes = ref([]);

    const formData = reactive({
      referenceNumber: null,
      obRefNo: 0,
      empId: store.state.getEmployeeId,
      employeeno: store.state.getProfileInfo.employee_number,
      department: store.state.getDepartment,
      designation: store.state.getDesignation,
      dateStart: null,
      timeStart: null,
      dateEnd: null,
      timeEnd: null,
      numberHours: 0,
      description: null,
      remarks: null,
      requestedBy: store.state.getUserLog,
    });

    onMounted(() => {
      store.commit('globalDate');
    });

    const sortedDtrs = computed(() => {
      return dtrs.value
        .map((item, originalIndex) => ({ item, originalIndex }))
        .sort((a, b) => {
          if (!a.item.timelog) return 1;
          if (!b.item.timelog) return -1;
          return a.item.timelog.localeCompare(b.item.timelog);
        });
    });
    const handlerCategory = () => {
      const selected = correctionTypes.find((t) => t.code === attendanceCorrType.value);

      filteredCategoryTypes.value = selected ? categoryTypes.filter((c) => c.group === selected.group) : [];

      attendanceCategory.value = '';
      dtrs.value = [];
      isDTR.value = false;
      DTRRemarks.value = '';
    };
    const addTime = () => {
      if (!timelog.value) {
        isAlert.value = true;
        isStatus.value = true;
        setTimeout(() => {
          isStatus.value = false;
        }, 4000);
        return;
      }

      const io = attendanceCorrType.value === 'MMTI' ? 'I' : 'O';

      dtrs.value.push({
        timelog: timelog.value,
        io,
        period: attendanceCategory.value, // "Morning" | "Afternoon"
        manual: true,
      });

      timelog.value = null;
    };

    // Removes the item at the given index from the dtrs list.
    // The index passed in must be the ORIGINAL dtrs index (sortedDtrs
    // carries this as entry.originalIndex), not the position in the
    // sorted/displayed list.
    // Note: this only mutates local state. If the item was fetched from
    // getDTRs() (item.manual is falsy), removing it here does NOT delete
    // anything server-side — it just drops it from the on-screen list.
    const removeTime = (index) => {
      dtrs.value.splice(index, 1);
    };

    const handleSubmit = async () => {
      handleValidation(formData);
    };

    const clearFormField = (value) => {
      if (value) {
        setTimeout(function () {
          formData.referenceNumber = null;
          formData.obRefNo = 0;
          formData.dateStart = null;
          formData.timeStart = null;
          formData.dateEnd = null;
          formData.timeEnd = null;
          formData.numberHours = 0;
          formData.description = null;
          formData.remarks = null;
          formData.requestedBy = store.state.getUserLog;
          buttonMessageVisible.value = false;
          dtrs.value = [];
          isDTR.value = false;
          DTRRemarks.value = '';
          attendanceCategory.value = '';
          attendanceCorrType.value = '';
          filteredCategoryTypes.value = [];
        }, 1100);
      }
    };

    const handleValidation = (formData) => {
      const validate = [];
      Object.entries(formData).forEach(([key, value]) => {
        if (attendanceCorrType.value === 'FNO') {
          if (key !== 'dateEnd' && key !== 'obRefNo' && key !== 'referenceNumber' && key !== 'timeEnd' && key !== 'remarks' && key !== 'numberHours') {
            if (!value) {
              validate.push(key);
            }
          }
        } else if (attendanceCorrType.value === 'OC') {
          if (key !== 'remarks' && key !== 'obRefNo') {
            if (!value) {
              validate.push(key);
            }
          }
        }
      });

      if (isDTR.value || isInvalidTime.value) {
        isStatus.value = true;
        isAlert.value = true;
        store.state.formErrorMessage = `There was a problem with your submission. Please review the fields that require your attention.`;
      } else if (validate.length) {
        isAlert.value = true;
        isStatus.value = true;
        store.state.formErrorMessage = `All Fields Required (*)`;
      } else {
        Swal.fire({
          title: 'Are you sure?',
          text: 'You want to submit this request.',
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Submit',
        }).then((result) => {
          if (result.isConfirmed) {
            buttonMessageVisible.value = true;
            emit('isLoaded');
          }
        });
      }
      setTimeout(() => {
        isStatus.value = false;
      }, 8000);
    };

    const getDTRs = async () => {
      try {
        const empNum = store.state.getProfileInfo.employee_number;
        const { data } = await axios.get(`/api/dtrs/attendance/${empNum}`, {
          params: {
            datelog: formData.dateStart,
          },
        });
        dtrs.value = data;
        console.log(data);
      } catch (error) {
        store.commit('errorHandler', error);
      }
    };

    return {
      formData,
      isStatus,
      isAlert,
      clearFormField,
      handleValidation,
      handleSubmit,
      isDTR,
      DTRRemarks,
      pastDates,
      correctionTypes,
      attendanceCorrType,
      getDTRs,
      dtrs,
      sortedDtrs,
      isInvalidTime,
      buttonMessageVisible,
      categoryTypes,
      filteredCategoryTypes,
      handlerCategory,
      attendanceCategory,
      timelog,
      addTime,
      removeTime,
      dtrOrigTimeOut,
    };
  },
};
</script>

<style scoped>
.checkbox-container {
  display: flex;
  align-items: center;
  height: 20px;
  margin-bottom: 20px;
}

.checkbox-container label {
  margin-right: 14px;
}
.checkbox-container .input input {
  margin-top: 6px;
  cursor: pointer;
  width: 25px;
  text-align: center;
}

.dtr-group {
  margin-bottom: 24px;
}

.dtr-group > label {
  display: block;
  margin-bottom: 10px;
}

.dtr-time-list {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin: 0;
  padding: 0;
}

.dtr-time-list .input {
  width: 100%;
  margin: 0;
  padding: 0;
}

.dtr-row {
  display: flex;
  align-items: center;
  width: 100%;
  max-width: 300px;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 10px 14px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

.dtr-row:focus-within {
  border-color: #3085d6;
  box-shadow: 0 0 0 2px rgba(48, 133, 214, 0.15);
}

.dtr-row input[type='time'] {
  border: none;
  background: transparent;
  font-size: 0.95rem;
}

.io-label {
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.5px;
  width: 40px;
  text-align: right;
}

.io-in {
  color: #2e7d32;
}

.io-out {
  color: #c62828;
}

/* Highlights a freshly-added (manual) entry with a green border + soft glow */
.dtr-row--new {
  border-color: #2e7d32;
  box-shadow: 0 0 0 2px rgba(46, 125, 50, 0.15);
  animation: new-entry-pop 0.3s ease-out;
}

@keyframes new-entry-pop {
  from {
    box-shadow: 0 0 0 5px rgba(46, 125, 50, 0.25);
  }
  to {
    box-shadow: 0 0 0 2px rgba(46, 125, 50, 0.15);
  }
}

.new-badge {
  display: inline-block;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.3px;
  color: #2e7d32;
  background: #e8f5e9;
  border: 1px solid #a5d6a7;
  border-radius: 10px;
  padding: 2px 8px;
}

.remove-btn {
  background: #fdecea;
  color: #c62828;
  border: 1px solid #f5c6cb;
  border-radius: 6px;
  padding: 6px 12px;
  font-size: 0.8rem;
  cursor: pointer;
  transition: background 0.15s ease;
}

.remove-btn:hover {
  background: #f8d7da;
}

@media (max-width: 480px) {
  .dtr-row {
    max-width: 100%;
    padding: 12px 16px;
  }
}
</style>
